import Avatar from './avatar';
import AvatarGroup from './avatar-group';
var DefaultAvatar = Avatar;
DefaultAvatar.Group = AvatarGroup;
export default DefaultAvatar;
//# sourceMappingURL=index.js.map